import { TEMPLATE_SETTINGS } from '../type';

// store or update the demand name map fetched from API
export const setDemandNameMap = (demandNameMap) => ({
    type: TEMPLATE_SETTINGS.SET_DEMAND_NAME_MAP,
    payload: demandNameMap,
});
